import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Home, Heart, LayoutDashboard } from "lucide-react";
import { cn } from "@/lib/utils";

const navItems = [
  {
    to: "/",
    labelKey: "nav.journal",
    icon: Home,
  },
  {
    to: "/overview",
    labelKey: "nav.overview",
    icon: LayoutDashboard,
  },
  {
    to: "/vows",
    labelKey: "nav.vows",
    icon: Heart,
  },
] as const;

export function BottomNav() {
  const { t } = useTranslation();

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 border-t border-gray-100 dark:border-[#1E3A5F] bg-white/95 dark:bg-[#0D1117]/95 backdrop-blur supports-[backdrop-filter]:bg-white/60 dark:supports-[backdrop-filter]:bg-[#0D1117]/60 pb-[env(safe-area-inset-bottom)]">
      <div className="flex h-16 items-center justify-around px-2">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === "/"}
            className={({ isActive }) =>
              cn(
                "flex flex-col items-center gap-1 rounded-lg px-3 py-1.5 text-xs font-medium transition-colors relative",
                isActive
                  ? "text-vajra-blue dark:text-vajra-cyan"
                  : "text-gray-400 dark:text-muted-foreground hover:text-gray-600 dark:hover:text-foreground"
              )
            }
          >
            {({ isActive }) => (
              <>
                <item.icon
                  className={cn(
                    "h-5 w-5 transition-colors",
                    isActive
                      ? "text-vajra-blue dark:text-vajra-cyan"
                      : "text-gray-400 dark:text-muted-foreground"
                  )}
                />
                <span>{t(item.labelKey)}</span>
                {isActive && (
                  <div className="absolute -top-px left-1/2 h-0.5 w-8 -translate-x-1/2 rounded-b bg-vajra-blue dark:bg-vajra-cyan" />
                )}
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
